<template>
  <div class="mt-5 mx-3">
    <!-- <h1 class='mx-4 my-4 headline'><v-icon class="mr-3 mt-0 pt-0">add_location</v-icon> <span class="mt-4" >{{ title }}</span></h1> -->
    <locations-table :items="this.displayedData"></locations-table>
  </div>
</template>

<script>
import axios from '../../../static/axios.js'
import Location from '@/components/locations/Location.vue'
import FilterBox from '@/components/artworks/FilterBox'
import LocationsTable from '@/components/locations/LocationsTable'

export default {
  data: function() {
    return {
      displayedData: [],
      location: {
        name: ''
      },
      locations: [],
      results: []
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   // getPost(to.params.id, (err, post) => {
  //     next(vm => vm.switchOwnership(to))
  //     // console.log('beforeRouteEnter')
  //   // })
  // },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  // beforeRouteUpdate(to, from, next) {
  //   // console.log('beforeRouteUpdate')
  //   this.displayedData = null
  //   // getPost(to.params.id, (err, post) => {
  //   this.switchOwnership(to)
  //   next()
  //   // })
  // },
  created: function() {
    this.$store.dispatch('loadLocations')
  },
  methods: {
    // switchOwnershipTop(switchStatus) {
    //   // console.log(switchStatus)
    //   if (switchStatus) {
    //   } else {
    //     this.switchOwnership(this.$route)
    //   }

    // // switchCategory (to) {
    // //   switch (to.params.location_categories) {
    // //     case 'artwork_acquisition_source':
    // //       this.displayedData = this.$store.state.collection
    // //       break
    // //     case 'device_acquisition_company':
    // //       this.displayedData = this.$store.state.pac_fvh
    // //       break
    // //   }
    // },
    // filterLocations (category) {
    //   locations = this.results.filter(function(c)  {
    //       return results.filter(function(c) {
    //         return c.category == category
    //     }).length > 1
    //   })
    //   this.displayedData = locations

    //   for (location in this.results) {
    //     if (location.category == category) {
    //         this.results[artist].artworks[artwork].splice(1,1)
    //     }
    //   }
    //   let artists = ''
    //   artists = this.storedData.filter(function(artist)  {
    //     return artist.artworks.filter(function(artwork) {
    //       return artwork.ownership == ownership
    //     }).length > 1
    //   })
    //   this.displayedData = artists
    // },
    switchOwnership(to) {
      // console.log('switchOwnership')
      // console.log(to.params.ownership)
      // this.displayedData = this.$store.state.collection

      this.displayedData = this.$store.state.locations.filter(function(a) {
        return a.cateogory == to.params.ownership
      })
      // switch (to.params.ownership) {
      //   case 'artwork_acquisition_source':
      //     // console.log(to.params.ownership)
      //     this.displayedData = this.$store.state.locations
      //     // console.log(this.displayedData)
      //     break
      //   case 'artwork_acquisition_source':
      //     // console.log(to.params.ownership)
      //     this.displayedData = this.$store.state.artworks.filter(function(a) {
      //       return a.cateogory == to.params.ownership
      //     })
      //     break
      //   case 'pdcFvh':
      //     // console.log(to.params.ownership)
      //     this.displayedData = this.$store.state.artworks.filter(function(a) {
      //       return a.ownership == 7
      //     })
      //     break
      //   case 'pacMr':
      //     // console.log(to.params.ownership)
      //     this.displayedData = this.$store.state.artworks.filter(function(a) {
      //       return a.ownership == 10
      //     })
      //     break
      //   case 'oldMasters':
      //     // console.log('case=' + to.params.ownership)
      //     // console.log(this.$store.state.oldMasters.length)
      //     this.displayedData = this.$store.state.artworks.filter(function(a) {
      //       return a.ownership == 9
      //     })
      //     break
      //   case 'deaccession':
      //     // console.log(to.params.ownership)
      //     this.displayedData = this.$store.state.artworks.filter(function(a) {
      //       return a.ownership == 5
      //     })
      //     break
      //   default:
      //   this.displayedData = this.$store.state.deaccession
    }
  },

  computed: {
    // title() {
    //   let title = 'Artwork Locations'
    //   // if (this.$route.fullPath == '/locations/oldMasters') {
    //   //   title = 'Old Masters'
    //   // } else if (this.$route.fullPath == '/locations/deaccession') {
    //   //   title = 'Deaccessioned'
    //   // } else if (this.$route.fullPath == '/locations/collection') {
    //   //   title = 'TBA21 Collection'
    //   // } else if (this.$route.fullPath == '/locations/pacFvh') {
    //   //   title = 'Private Art Collection FTB'
    //   // } else if (this.$route.fullPath == '/locations/pdcFvh') {
    //   //   title = 'Private Design Collection FTB'
    //   // } else if (this.$route.fullPath == '/locations/pacMr') {
    //   //   title = 'Private Art Collection MR'
    //   // }
    //   return title
    // },
    // processedLocations () {
    //   let locations = this.results
    //   // this.locations.map(location => {
    //   //   let a = location
    //   //   location.first_name = a ? a.first_name : 'nema meno'
    //   // })
    //   return locations
    // }
  },

  // filters: {
  //   capitalize: function (a) {
  //     if (!a) return ''
  //     a = a.toString()
  //     return a.charAt(0).toUpperCase() + a.slice(1)
  //   }
  // },
  components: {
    Location,
    LocationsTable
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/locations/Locations.vue